import React, { useEffect, useState } from 'react';
import { Modal } from '@qover/organisms';
import { FormattedMarkdown } from '@qover/react-intl';
import { useFieldValue } from '@qover/hooks';
import { TripType } from '@qover-private/protos-web/qover/dojo/travel/v1/terms';
import styled from 'styled-components';

type TrDiscontinuanceModal = {
  linkTo: string;
  onClose?: () => void;
};

const DiscontinuanceModal = styled(Modal)`
  padding: 10px;

  @media (min-width: ${({ theme }) => theme.breakpoints.minWidth.S}) {
    padding: 40px 54px 54px 54px;;
  }
`;

export function TrDiscontinuanceModal(props: TrDiscontinuanceModal) {
  const [mounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  return (
    <DiscontinuanceModal hideOverflow onClickOutside={props.onClose}>
      <FormattedMarkdown
        id="travel.discontinuance"
        defaults="[singletrip]()"
        options={{
          overrides: {
            a: (p: any) => <a {...p} href={props.linkTo} />,
          },
        }}
      />
    </DiscontinuanceModal>
  );
}

export function TrDiscontinuanceModalWithTripCheck(
  props: TrDiscontinuanceModal,
) {
  const tripType = useFieldValue<TripType>('terms.tripType');

  if (tripType === TripType.TRIP_TYPE_SINGLE_TRIP) {
    return null;
  }

  return <TrDiscontinuanceModal {...props} />;
}
